export default __webpack_public_path__ + "506e2286bef8149907d6ce1e683a1771.svg";